import React from 'react';
import { Headline4 } from '../../../common/typography';
import {
  ActionsButtonsContainer,
  AssigneeContainer,
  AssigneeDueDateContainer,
  AssigneeTitle,
  DeleteButton,
  DueDateContainer,
  DueDateTitle,
  EditButton,
  PreviewCardContainer,
  PreviewCardDepartments,
  PreviewCardSubDepartments,
  PreviewCardTitle,
} from './SelfAssessmentPreviewCard.styled';

import { EditPencil } from '../../../common/icons/EditPencil';
import { Delete } from '../../../common/icons/Delete';
import {
  SummaryCardTitle,
  SummaryCardTitleDepartment,
} from '../SelfAssessmentSummaryCard/SelfAssessmentSummaryCard.styled';
import {
  ISelfAssesmentDepartmentDetails,
  ISelfAssessmentSubDepartment,
} from '../../../@types/selfAssessment';
import { useTranslation } from 'react-i18next';
import { Nullable } from '../../../@types/genericTypes';

interface SelfAssessmentPreviewCardProps {
  assignee?: {
    id: Nullable<number>;
    text: string;
  };
  dueDate?: string | Date;
  departments?: ISelfAssesmentDepartmentDetails[];
  handleEdit: (assignereId: Nullable<number>) => void;
  handleDelete: (assignereId: Nullable<number>) => void;
}

export function SelfAssessmentPreviewCard ({
  assignee,
  dueDate,
  departments,
  handleEdit,
  handleDelete,
}: SelfAssessmentPreviewCardProps) {
  const { t } = useTranslation();
  const getSubDepartmentsLabel = (
    subDepartments: ISelfAssessmentSubDepartment[]
  ) => {
    return subDepartments
      .flatMap((subDepartment) => subDepartment.subDepartmentName)
      .join(', ');
  };

  return (
    <PreviewCardContainer>
      <PreviewCardTitle>
        <AssigneeDueDateContainer>
          <AssigneeContainer>
            <Headline4>
              {t('COMMON.SELF_ASSESSMENT.PAGES.PREVIEW.ASSIGNED_TO')}
            </Headline4>
            <AssigneeTitle>{assignee && assignee.text}</AssigneeTitle>
          </AssigneeContainer>
          <DueDateContainer>
            <Headline4>
              {t('COMMON.SELF_ASSESSMENT.PAGES.PREVIEW.DUE_DATE')}
            </Headline4>
            <DueDateTitle>{dueDate && dueDate}</DueDateTitle>
          </DueDateContainer>
        </AssigneeDueDateContainer>
        <ActionsButtonsContainer>
          <EditButton onClick={() => assignee && handleEdit(assignee.id)}>
            <EditPencil />
          </EditButton>
          <DeleteButton onClick={() => assignee && handleDelete(assignee.id)}>
            <Delete />
          </DeleteButton>
        </ActionsButtonsContainer>
      </PreviewCardTitle>
      <PreviewCardDepartments>
        {departments &&
          departments.map((department) => {
            return (
              // tslint:disable-next-line:jsx-key
              <SummaryCardTitle>
                <SummaryCardTitleDepartment>{`${department.departmentName}: `}</SummaryCardTitleDepartment>
                <PreviewCardSubDepartments>
                  {getSubDepartmentsLabel(department.subDepartments) || '-'}
                </PreviewCardSubDepartments>
              </SummaryCardTitle>
            );
          })}
      </PreviewCardDepartments>
    </PreviewCardContainer>
  );
}
